<nz-table
  nzShowSizeChanger
  [nzData]="saleCurrentData$ | async"
  [nzFrontPagination]="false"
  [nzLoading]="isLoading$ | async"
  [nzTotal]="saleCurrentTotal$ | async"
  [nzPageSize]="pageSize"
  [nzPageIndex]="pageIndex"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th scope="col" nzColumnKey="status">
        {{ 'general.status' | translate }}
      </th>
      <th
        scope="col"
        nzColumnKey="id"
        [nzSortFn]="true"
        [nzSortOrder]="'descend'"
      >
        {{ 'general.number' | translate }}
      </th>
      <th scope="col" nzColumnKey="member">
        {{ 'memberModule.member' | translate }}
      </th>
      <th scope="col" nzColumnKey="date">
        {{ 'general.date' | translate }} / {{ 'general.time' | translate }}
      </th>
      <th scope="col" nzColumnKey="organization">
        {{ 'organizationModule.organization' | translate }}
      </th>
      <th scope="col" nzColumnKey="total">Total</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let sale of saleCurrentData$ | async">
      <td>
        <span
          [ngClass]="{
            'bg-soft-success':
              (sale | saleFinalStatusCode) === saleStatusCode.DONE,
            'bg-soft-primary':
              (sale | saleFinalStatusCode) === saleStatusCode.INFLIGHT,
            'bg-soft-secondary':
              (sale | saleFinalStatusCode) === saleStatusCode.CANCELLED,
            'bg-soft-info':
              (sale | saleFinalStatusCode) === saleStatusCode.PENDING_REQUIRED
          }"
          class="badge"
        >
          {{
            'saleModule.statusCode' + (sale | saleFinalStatusCode) | translate
          }}
        </span>
      </td>
      <td>
        <a [routerLink]="['/sales/', sale.id]"> #{{ sale.id }} </a>
      </td>
      <td>
        {{ (memberEntities$ | async)[sale.customerPersonId]?.firstName }}
        {{ (memberEntities$ | async)[sale.customerPersonId]?.lastName }}
      </td>
      <td>
        {{
          sale.date
            | date
              : 'd MMMM yyyy'
              : null
              : (configService.selectedLang$ | async)
        }}
      </td>
      <td>
        {{ (organizationEntities$ | async)[sale.organizationId]?.description }}
      </td>
      <td>{{ sale.total | currency }}</td>
    </tr>
  </tbody>
</nz-table>
